export const dictionary = {
  header: {
    switchToDarkMode: 'Dark mode',
    switchToLightMode: 'Light mode',
  },

  auth: {
    login: {
      title: 'BeyonDegrees',
      subTitle: 'Continue to',

      buttonLogin: 'Login',
      buttonLoginWithGoogle: 'Continue with Google',
      buttonLoginWithMicrosoft: 'Continue with Microsoft',
      buttonCreateAccount: 'Create account',
      buttonResetPassword: 'Reset password',
      buttonForgotPassword: 'Forgot password?',
      dontHaveAccount: 'Don\'t have an account?',
    },

    signUp: {
      title: 'Sign up',

      buttonSignup: 'Sign up',
      buttonLogin: 'Login',
      alreadyHaveAccount: 'Already have an account?',

      passWordMustContain: 'Your password must contain:',
      passwordCharacterCount: 'At least 8 characters',
      passwordOptionsTitle: 'At least 1 of each of the following',
      passwordLowercase: 'Lower case letters (a-z)',
      passwordUppercase: 'Upper case letters (A-Z)',
      passwordNumbers: 'Numbers (0-9)',
      passwordSpecialCharacters: 'Special characters (e.g. !@#$%^&*)',
    },

    resetPassword: {
      title: 'Reset password',

      buttonLogin: 'Back to Login',
      buttonReset: 'Reset password',

      passwordResetError: 'Error resetting password, please try again',

      passwordResetEmailSent: 'Password Reset Email Sent',
    },

    validations: {
      userWithThisEmailAlreadyExists: 'User with this email already exists',
      userNotFound: 'User not found',
      passwordsDoNotMatch: 'Passwords do not match',
      emailOrPasswordWrong: 'Email or password wrong',
      thePasswordMustBeAtLeast8CharactersLong: 'The password must be at least 8 characters long',
    },

    impersonate: {
      noToken: 'Token is not present',
      invalidToken: 'Token is invalid or expired',
    },

    firebase: {
      errors: {
        'auth/account-exists-with-different-credential': 'This account already exists with a different login provider',
      },
    },
    divider: 'or',
  },

  users: {
    labelTypeCustomer: 'Customer',
    labelTypeAdmin: 'Admin',
    labelTypeStaff: 'Staff',

    invite: {
      dialog: {
        title: 'Invite team members',
        placeholderEmail: 'Email, comma separated',
        buttonInvite: 'Send invite',
        invitationSentInfo: (email: string) => `Invitation to ${email} sent`,
      },

      title: 'Team invitation',
      subtitle: (company?: string) => company ? `You've been invited to join ${company}'s team` : 'You\'ve been invited to join a team',
      buttonAcceptInvitation: 'Create account',
      inviteButton: 'Invite Team Member',
    },

    team: {
      title: 'Team',

      detailsLabel: 'Details',

      buttonInvite: 'Invite user',
    },

    create: {
      title: 'Create user',
      buttonCreate: 'Create user',
    },

    edit: {
      buttonEdit: 'Edit user',
      buttonDelete: 'Delete user',
      deleteConfirmation: 'Are you sure you want to delete this user?',
    },

    resetAccount: {
      dialog: {
        title: 'Reset your matches',
        firstTime: (months: number) => `You created your account ${months} month${months === 1 ? '' : 's'} ago. Let's see how your Archetype has changed in that time. Click the button to Reset your matches.`,
        subsequent: (date: string) => `You last reset your account on ${date}. Let's see how your Archetype has changed since last time. Click the button to Reset your matches.`,
        buttonReset: 'Reset',
      },
    },
    supportContact: {
      dialog: {
        title: 'Need a hand?',
        subtitle: 'Our team is here to help. Whether you have a question about your results, your academic path, or anything else — just send us a message and we\'ll get back to you shortly.',
        placeholderMessage: 'Describe your question or concern…',
        buttonSend: 'Send Message',
        successMessage: 'Your message has been sent. We\'ll be in touch shortly.',
      },
    },
  },

  menu: {
    auth: {
      login: 'Log In',
      logout: 'Log Out',
      signUp: 'Signup',
    },
    dashboard: 'About me',
    disciplines: 'Disciplines',
    majors: 'Majors',
    universities: 'Universities',
    feedback: 'Feedback Check-in',
    understandMatches: 'Understand Your Matches',
    understandMatchesShort: 'Understand Matches',
    leaveReview: 'Leave Review',
    share: 'Share Archetype',
    settings: 'Settings',
    users: {
      list: 'Users',
      team: 'Team',
      myAccount: 'My account',
      create: 'Create user',
    },
    contactUs: 'Contact Us',
    resetAccount: 'Reset account',
  },

  forms: {
    fieldEmail: 'Email',
    fieldCode: 'Code',
    fieldPhone: 'Phone',
    fieldPassword: 'Password',
    labelOptional: '(Optional)',
    buttonCreate: 'Create',
    buttonEdit: 'Save changes',
    buttonDelete: 'Delete',
    fieldStartDate: 'Start date',
    fieldEndDate: 'End date',

    signup: {
      fieldRepeatPassword: 'Repeat Password',
    },
    user: {
      fieldName: 'Name',
      fieldMiddleName: 'Middle name',
      fieldLastName: 'Last name',
      fieldType: 'Type',
      fieldCompany: 'Company',
      fieldPosition: 'Position',
      fieldPicture: 'Upload picture',
      fieldSurname: 'Surname',
      fieldLocation: 'Location',
      fieldWantedDegree: 'I\'m working toward a...',
      fieldKnowsWantedMajor: 'I already know what I want to study',
      fieldWantedMajor: 'Preferred Major',
      fieldEmailDisabledHelper: 'Please contact support to change the email.',
      fieldWantedStudyDestination: 'I want to study',
      fieldWantedStudyDestinationDomestic: 'In my country',
      fieldWantedStudyDestinationAbroad: 'Abroad',
    },

    validations: {
      required: 'This Field is Required',
      invalidDate: 'Date is Invalid',
      outOfRangeAge: 'The age should be 18 and up',
      ageTooOld: 'The age should be less than 150',
      invalidEmail: 'Email is Invalid',
      takenEmail: 'Email is already in use',
      coupleEmailsMustBeUnique: 'Email must be different from partner email',
      invalidPhone: 'Phone number is Invalid',
      invalidYear: 'The year is incorrect',
      invalidPassword: 'Password is Invalid. It should be at least 8 characters long. With at least 1 number, one lowercase character, one uppercase character and one special character.',
      invalidFileSize: (max: string) => `File is too big. Maximum is ${max}`,
      invalidFileType: 'File type is not valid',
      minLength: (length: number | string) => `Need to have at least ${length} characters`,
      maxLength: (length: number | string) => `Can't have more than ${length} characters`,
      min: (value: number | string) => `Minimum value is ${value}`,
      max: (value: number | string) => `Maximum value is ${value}`,
      fullName: 'This field must contain at least first and last name',
      oneOrMoreFieldsAreIncorrect: 'One or more fields are incorrect.',
      memberInvitationAllEmailsValid: 'One or more emails is invalid.',
    },
  },

  filters: {
    fieldSearch: 'Search',
  },

  feedback: {
    changesSaved: 'Changes saved successfully',
    loading: 'Loading...',
  },

  dialogs: {
    defaultTitle: 'Are you sure you want to do this?',
    defaultContent: 'This action is irreversible.',
    buttonNo: 'No',
    buttonYes: 'Yes',
    buttonCancel: 'Cancel',
    buttonClose: 'Close',
  },

  errors: {
    noPagePermission: 'You are not allowed to view this page',
    somethingWentWrong: 'Something went wrong!',
  },

  routes: {

  },

  countries: {
    US: 'United States',
    AF: 'Afghanistan',
    AX: 'Aland Islands',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua And Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BQ: 'Bonaire, Sint Eustatius and Saba',
    BA: 'Bosnia And Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    CV: 'Cape Verde',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo, Democratic Republic of the',
    CK: 'Cook Islands',
    CR: 'CostaRica',
    CI: 'Cote d\'Ivoire',
    HR: 'Croatia',
    CU: 'Cuba',
    CW: 'Curacao',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    ET: 'Ethiopia',
    FK: 'Falkland Islands',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'GuineaBissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island and McDonald Islands',
    VA: 'Holy See (Vatican City State)',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'IsleOfMan',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KR: 'Korea, Republic of',
    KP: 'Korea, Democratic People\'s Republic of',
    XK: 'Kosovo',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: 'Lao People\'s Democratic Republic',
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MK: 'Macedonia',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia',
    MD: 'Moldova',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    NC: 'NewCaledonia',
    NZ: 'NewZealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MP: 'Northern Mariana  Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestine, State of',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Reunion',
    RO: 'Romania',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    BL: 'Saint Barthelemy',
    SH: 'Saint Helena',
    KN: 'Saint Kitts And Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin',
    PM: 'Saint Pierre And Miquelon',
    VC: 'Saint Vincent and the Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome and Principe',
    SA: 'SaudiArabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SX: 'Sint Maarten',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'SouthAfrica',
    GS: 'South Georgia and the South Sandwich Islands',
    SS: 'South Sudan',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Suriname',
    SJ: 'Svalbard and Jan Mayen',
    SZ: 'Swaziland',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan',
    TJ: 'Tajikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TL: 'TimorLeste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks and Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    UM: 'United States Minor Outlying Islands',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Vietnam',
    VG: 'British Virgin Islands',
    VI: 'US Virgin Islands',
    WF: 'Wallis and Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
  },
};

export default dictionary;
